import { create } from 'zustand';

/** Sidebar areas that can override the dashboard tenant filter locally. */
export type TenantPageScope = 'customers' | 'users' | 'notifications';

type PageOverrideMap = Partial<Record<TenantPageScope, string | null>>;

interface TenantFilterState {
  /** `null` means "All tenants". */
  globalTenantId: string | null;
  /** Per-page selection; `undefined` missing key → use `globalTenantId`. */
  pageOverride: PageOverrideMap;
  setGlobalTenant: (tenantId: string | null) => void;
  setPageTenant: (scope: TenantPageScope, tenantId: string | null) => void;
}

export const useTenantFilterStore = create<TenantFilterState>(set => ({
  globalTenantId: null,
  pageOverride: {},
  setGlobalTenant: tenantId =>
    set({
      globalTenantId: tenantId,
      pageOverride: {},
    }),
  setPageTenant: (scope, tenantId) =>
    set(state => ({
      pageOverride: { ...state.pageOverride, [scope]: tenantId },
    })),
}));

export function getEffectiveTenantId(
  scope: TenantPageScope,
  globalTenantId: string | null,
  pageOverride: PageOverrideMap
): string | null {
  if (Object.prototype.hasOwnProperty.call(pageOverride, scope)) {
    return pageOverride[scope] ?? null;
  }
  return globalTenantId;
}
